export default __webpack_public_path__ + "locales/ru/CreateEditRoomDialog.json?hash=910bb2cd486bf3bd326b85f0caf1e339";